import axios from "axios";

import config from "../../config";
/**
 * API utils for V2 API routes. For V1 APIs please continue using api-helper.js
 */
const axiosInstance = axios.create({
	baseURL: config.serverUrl
});

axiosInstance.interceptors.request.use((config) => {
	config.headers["Authorization"] = "Bearer randomToken1234567890";
	return config;
});

export default {
	axiosInstance
};
